import React, { Component, Fragment } from "react";
import { connect } from "react-redux";
import {GroundFloorDurableFunctionInstance} from "../../../../models/DurableFunctionInstance";
import DispatchProps from "../../../../utils/DispatchProps";
import {Doughnut} from "react-chartjs-2";
import {IRootState} from "../../../../store";
import _ from "lodash";
import {CommandBarButton} from "office-ui-fabric-react";

export const DEFAULT_CHART_COLOURS = ['#3366CC','#DC3912','#FF9900','#109618','#990099','#3B3EAC','#0099C6','#DD4477','#66AA00','#B82E2E','#316395','#994499','#22AA99','#AAAA11','#6633CC','#E67300','#8B0707','#329262','#5574A6','#3B3EAC'];

interface WorkloadResultsChartsProps {
    instances: GroundFloorDurableFunctionInstance[];
    onCloseClicked(): void;
}

interface WorkloadResultsChartsState {
    statusDoughnutData: any;
    statusMessageDoughnutData: any;
    nameDoughnutData: any;
}

class WorkloadResultsCharts extends Component<WorkloadResultsChartsProps & DispatchProps, WorkloadResultsChartsState> {

    constructor(props: WorkloadResultsChartsProps & DispatchProps) {
        super(props);
        
        this.state = {
            statusDoughnutData: {},
            statusMessageDoughnutData: {},
            nameDoughnutData: {}
        };
    }

    componentDidMount(): void {
        this.setChartData();
    }

    async componentDidUpdate(prevProps: Readonly<WorkloadResultsChartsProps & DispatchProps>, prevState: Readonly<WorkloadResultsChartsState>, snapshot?: any): Promise<void> {
        
        if(this.props.instances !== prevProps.instances)
        {
            this.setChartData();
        }
    }
    
    private setChartData() {
        
        const instancesGroupedByStatus = _.groupBy(this.props.instances,i => {
            if(i.failedAndAwaitingRestart)
            {
                return "Failed";
            }
            else
            {
                return i.runtimeStatus;
            }
        });
        const statusLabels = ["Completed", "Running", "Failed", "Terminated", "Pending"]
        const statusData = statusLabels.map(status => instancesGroupedByStatus[status]?.length || 0);
        
        const statusDoughnutData = {
            title: "Status",
            labels: statusLabels,
            datasets: [{
                data: statusData,
                backgroundColor: [
                    '#99c140',
                    '#e7b416',
                    '#cc3232',
                    '#000000',
                    '#0085F6'
                ]
            }]
        };
        
        const instancesGroupedByStatusMessage = _.groupBy(this.props.instances,i => i.customStatus?.message || "No Message");
        const statusMessageLabels = _.keys(instancesGroupedByStatusMessage).sort();
        const statusMessageData = statusMessageLabels.map(statusMessage => instancesGroupedByStatusMessage[statusMessage]?.length || 0);

        const statusMessageDoughnutData = {
            labels: statusMessageLabels,
            datasets: [{
                label: "Status message",
                data: statusMessageData,
                backgroundColor: DEFAULT_CHART_COLOURS
            }]
        };
        
        
        const instancesGroupedByName = _.groupBy(this.props.instances,i => i.workloadName || i.playlistName);
        const nameLabels = _.keys(instancesGroupedByName).sort();
        const nameData = nameLabels.map(name => instancesGroupedByName[name]?.length || 0);


        const nameDoughnutData = {
            labels: nameLabels,
            datasets: [{
                data: nameData,
                backgroundColor: DEFAULT_CHART_COLOURS
            }]
        };
        

        this.setState({
            statusDoughnutData,
            statusMessageDoughnutData,
            nameDoughnutData
        });
        
    }
    
    render(): JSX.Element {
        return (
            <Fragment>
                <div className="card card">
                    <div className="card__header">
                        <span className={"card__title"}>Workloads</span>
                        <CommandBarButton
                            iconProps={{iconName: "Cancel"}}
                            text="Close"
                            onClick={this.props.onCloseClicked}
                        />
                    </div>
                    <div className="card__content flex-column">
                        <div className={"flex-row flex--justify-content-space-around"}>
                            <div className="doughnut-holder">
                                <Doughnut data={this.state.statusDoughnutData} height={1} width={1} />
                            </div>
                            <div className="doughnut-holder">
                                <Doughnut data={this.state.statusMessageDoughnutData} height={1} width={1} />
                            </div>
                            <div className="doughnut-holder">
                                <Doughnut data={this.state.nameDoughnutData} height={1} width={1} />
                            </div>
                        </div>
                    </div>
                </div>
            </Fragment>
        );
    }
}

export default connect(
    (state: IRootState, ownProps: { instances: GroundFloorDurableFunctionInstance[],onCloseClicked: () => void }): WorkloadResultsChartsProps => {
        return {
            instances: ownProps.instances,
            onCloseClicked:ownProps.onCloseClicked
        };
    }
)(WorkloadResultsCharts)